module.exports = __webpack_public_path__ + "img/aliexpress.1553ab6d.png";